/// <reference path="../../app.ts" />
namespace Cfnc {

    interface ICampusSearchFilterCheckbox extends ng.IDirective {

    }

    interface ICampusSearchFilterCheckboxScope extends ng.IScope {
        filterGroup: IAvaliableFiltersGroup;
        filter: IAvailableFilterOption;
        ngModel: IAvaliableFiltersGroup[];
        selected: boolean;
        ngDisabled: boolean;
        vm: any;
    }

    class CampusSearchFilterCheckbox implements ICampusSearchFilterCheckbox {
        static directiveId: string = "campusSearchFilterCheckbox";
        templateUrl = "/app/directives/campusSearchFilter/campusSearchFilterCheckbox.html";
        replace: boolean = true;
        restrict: string = "E";
        scope: any =
        {
            ngModel: "=",
            filterGroup: "=",
            filter: "=",
            action: "&",
            ngDisabled: "="
        };

        constructor(private $window: ng.IWindowService) {
        }

        link = (scope: ICampusSearchFilterCheckboxScope, element, attrs) => {
            scope.vm = {
                filterGroup: scope.filterGroup,
                filter: scope.filter,
                selected: true,
                ngDisabled: scope.ngDisabled
            }

            scope.selected = false;

            scope.$watch("filter",(newValue) => {
                scope.vm.filter = newValue;
            });

            scope.$watch("ngModel",(newValue: Array<any>) => {
                var index = _.findIndex(newValue,function(x) { return x.key == scope.vm.filterGroup.key; });
                if (index > -1) {
                    if (scope.vm.filter.key === "ROTC" && _.findKey(newValue[index].filters,function(x) { return x.key == "ArmyROTC" }))
                        scope.selected = true;
                    else if (scope.vm.filter.key === "GreekHousing" && _.findKey(newValue[index].filters,function(x) { return x.key == "FraternityHousingAvailable" }))
                        scope.selected = true;
                    else if (scope.vm.filter.key === "FederalStateGrants" && _.findKey(newValue[index].filters,function(x) { return x.key ==  "FederalGrantsAndScholarship" }))
                        scope.selected = true;
                    else {
                        var filterIndex = _.findIndex(newValue[index].filters,(f: any) => { return f.key == scope.vm.filter.key });
                        scope.selected = filterIndex > -1 ? true : false;
                    }
                } else {
                    scope.selected = false;
                }
            }, true);

            scope.$watch("selected",(newValue) => {
                if (scope.ngModel) {
                    var groups = scope.ngModel.length > 0 ? _.filter(scope.ngModel, { key: scope.filterGroup.key }) : null;
                    if (newValue) {
                        if (!groups || groups.length < 1) {
                            var newGroup: IAvaliableFiltersGroup = {
                                key: scope.filterGroup.key,
                                category: scope.filterGroup.category,
                                filters: []
                            }

                            if (scope.filter.filters) {
                                Array.prototype.push.apply(newGroup.filters, scope.filter.filters);
                            } else {
                                newGroup.filters.push(scope.filter);
                            }

                            scope.ngModel.push(newGroup);
                        } else {
                            var group = groups[0];
                            var filterIndex = _.findIndex(group.filters, (f: any) => { return f.key == scope.filter.key });
                            if (scope.filter.filters) {
                                Array.prototype.push.apply(group.filters, scope.filter.filters);
                            } else if (filterIndex === -1) {
                                group.filters.push(scope.filter);
                            }
                        }
                    } else {
                        if (groups && groups.length > 0) {
                            var group = groups[0];

                            if (scope.filter.filters) {
                                angular.forEach(scope.filter.filters,(filter) => {
                                    _.remove(group.filters, { key: filter.key });
                                });
                            } else {
                                _.remove(group.filters, { key: scope.filter.key });
                                if (scope.filter.key === "PrivateReligious") {
                                    _.remove(scope.ngModel, { key: "Religions" });
                                }

                            }

                            if (group.filters.length < 1) {
                                _.remove(scope.ngModel, { key: group.key });
                            }
                        }
                    }
                }
            });
        }
    }

    angular.module("app").directive(CampusSearchFilterCheckbox.directiveId, ["$window", $window =>
        new CampusSearchFilterCheckbox($window)
    ]);
}